import { render, staticRenderFns } from "./SecondaryChildNavItem.vue?vue&type=template&id=d214f49c&scoped=true"
import script from "./SecondaryChildNavItem.vue?vue&type=script&lang=js"
export * from "./SecondaryChildNavItem.vue?vue&type=script&lang=js"
import style0 from "./SecondaryChildNavItem.vue?vue&type=style&index=0&id=d214f49c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d214f49c",
  null
  
)

export default component.exports